<template>
  <div id="app1" style="height:411px;">
    <video id="myvideo" @click="click" controls="true" height="100%" width="100%" muted></video>
  </div>
</template>

<script>
import flv from 'flv.js'

export default {
  name: 'app1',
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
      player: null,
      playing: true
    }
  },
  created () {
    if (flv.isSupported()) {
      this.player = flv.createPlayer({
        type: 'flv',
        url: this.url
      }, { lazyLoadMaxDuration: 30 })
    }
  },
  mounted () {
    var video = document.querySelector('#myvideo')
    this.player.attachMediaElement(video)
    this.player.load()
    this.player.play()
  },
  methods: {
    pause () {
      this.player.pause()
      this.playing = false
    },
    click () {
      if (this.playing) {
        this.player.pause()
        this.playing = false
      } else {
        this.player.play()
        this.playing = true
      }
    }
  }
}
</script>
